import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import queryString from 'query-string';

interface IGetTemplateRecording {
  templateId: number | null;
}
export default function useGetTemplateRecording() {
  const getTemplateRecording = ({ templateId }: IGetTemplateRecording) => {
    const queryParams = queryString.stringify({ templateId });
    const request: Request = {
      url: `${ENDPOINTS.template.recording.file}?${queryParams}`,
      config: {
        method: 'get',
      },
    };

    return client(request);
  };

  const { data, ...rest } = useMutation<
    Response<string | undefined>,
    CronoError,
    IGetTemplateRecording
  >(getTemplateRecording);

  return { data, ...rest };
}
